import React from "react";
import { article } from "@Api";
import { WrapperContext, WrapperProvider } from "@Components/article/categoryArticle/fixedNav";
import styles from "./detail.module.less";
import { host } from "@Services/url";
import "@Styles/global.less";
import ArticlesRank from "@Components/tags/ArticlesRank";
import HotMovie from "@Components/tags/HotMovie";
import withLayout from "@Src/layouts/withLayout";
import { setUrlFormat } from "@Lib/common";

const { fetchV3Articles, fetchKindTopicDetail } = article;

interface itemType {
  id: string;
  type: string;
  title: string;
  thumb: string;
  tag: string;
  time: string;
  visits: string;
  link: string;
}

interface articleNavType {
  [key: string]: itemType[];
}

interface IState {
  dataSource: itemType[];
  nextPage: string;
  title: string;
  description: string;
  content: string;
  kind: string;
  nav: string[];
  kinds: itemType[];
  dataSourceNav: articleNavType;
  views: number;
  articleCount: number;
  isExpan: boolean;
  articlesList: itemType[];
  id: string;
}

const { articleCategory } = article;
class KindListDetail extends React.Component<{}, IState> {
  readonly state: IState = {
    dataSource: [],
    nextPage: "",
    title: "",
    content: "",
    nav: [],
    kinds: [],
    kind: "",
    dataSourceNav: {},
    views: 0,
    articleCount: 0,
    isExpan: false,
    articlesList: [],
    id: "",
  };

  private fetch = async (id) => {
    const res: any = await fetchKindTopicDetail({ id: id });
    if (res && res.status === 12000) {
      this.setState({
        dataSource: res.data.list,
        title: res.data.title,
        kinds: res.data.kinds || [],
        kind: res.data.kinds.map((item: any) => item.kindId).join(","),
        content: res.data.content,
      });
    }
  };

  static contextType = WrapperContext;

  componentDidMount() {
    const params = location.pathname.split("/");

    if (params && params[params.length - 1] && Number(params[params.length - 1])) {
      this.setState({
        id: params[params.length - 1],
      });
      params[params.length - 1] && this.fetch(params[params.length - 1]);
    }

    // var pageChange = {
    //   event: "pageChange",
    //   virtualPageUrl: location.pathname + location.search,
    //   dv_page: "文章列表",
    //   dv_channel: "文章",
    //   dv_category: "精華合輯",
    // };
    // window.dataLayer && window.dataLayer.push(pageChange);
  }


  render() {
    const { title, content, kinds, kind } = this.state;

    return (
      <WrapperProvider>
        <div className={styles["home-category"]}>
          <div className={styles["content"]}>
            <div className={styles["bread-crumbs"]}>
              您當前的位置： <a href={`${host.c}/Models`}>新車首頁</a> &gt; <a href='/topic'>車款專題</a> &gt;{" "}
              {title}
            </div>

            <div className={styles["bread-content"]}>
              <div className='w-778 border-0 border-r-1 border-solid border-[#979797] pr-40 mr-40'>
                <div className={styles["top-wrapper"]}>
                  {title && (
                    <h1 className={styles["list-title"]}>
                      <span>#</span>
                      {title}
                      <span>#</span>
                    </h1>
                  )}
                  {!!content && (
                    <div
                      className={styles["list-html"]}
                      dangerouslySetInnerHTML={{
                        __html: content,
                      }}
                    />
                  )}

                  {Array.isArray(kinds) &&
                    !!kinds.length &&
                    kinds.map((item: any, index) => (
                      <div
                        className='border-1 border-solid border-[#E8E8E8] rounded-6 pl-10 flex justify-start items-start h-264 mb-20'
                        key={index}
                      >
                        <div className='w-260 h-full flex justify-center flex-col'>
                          <a
                            href={`${host.c}/${setUrlFormat(item.brandName)}/${setUrlFormat(item.kindName)}/Summary.html`}
                          >
                            <img className='w-260 h-174 mb-10' src={item.thumb} alt='' />
                          </a>
                          <div className='flex w-full justify-between'>
                            <a
                              href={`${host.c}/${setUrlFormat(item.brandName)}/${setUrlFormat(
                                item.kindName,
                              )}/HDPhoto.html`}
                              className={`${item.isInquiry === 1 ? "w-80" : "w-120"
                                } h-40 border-1 border-solid border-[#979797] flex justify-center items-center rounded-6 text-14 text-[#333333]`}
                            >
                              圖片
                            </a>
                            <a
                              href={`${host.c}/${setUrlFormat(item.brandName)}/${setUrlFormat(
                                item.kindName,
                              )}/Specification.html`}
                              className={`${item.isInquiry === 1 ? "w-80" : "w-120"
                                } h-40 border-1 border-solid border-[#979797] flex justify-center items-center rounded-6 text-14 text-[#333333]`}
                            >
                              規格配備
                            </a>
                            {item.isInquiry === 1 && (
                              <a href={`/ask/price?b=${item.brandId}&k=${item.kindId}&source=車款合輯頁-一鍵詢價`}>
                                <p className='w-80 h-40 border-1 border-solid border-[#FF4333] flex justify-center items-center bg-[#FF4333] text-[#FFFFFF] rounded-6 text-14'>
                                  一鍵詢價
                                </p>
                              </a>
                            )}
                          </div>
                        </div>
                        <div className='flex-1 pl-20'>
                          <div
                            className='flex flex-col h-134 cursor-pointer'
                            style={{ background: "linear-gradient(225deg,#f3f6ff, rgba(255,255,255,0.00))" }}
                          >
                            <a
                              href={`${host.c}/${setUrlFormat(item.brandName)}/${setUrlFormat(item.kindName)}/Summary.html`}
                              className='border-0 border-b-1 border-solid border-[#E8E8E8] mt-20 mb-14 text-[#333]'
                            >
                              <h2 className='text-20 font-bold mb-16 line-clamp-1 text-[#333333]'>{item.fullName}</h2>
                              <div className='flex justify-start mb-12'>
                                <div className='text-[#666666] text-16 w-240'>
                                  原廠參考價：<span className='text-[#FF0000]'>{item.price}</span>
                                </div>
                                <div className='text-[#666666] text-16'>{`${item.energyType === 5 ? `動力：電動` : `排量：${item.gas}`}`}</div>
                              </div>
                              <div className='flex justify-start mb-12 '>
                                <div className='text-[#666666] text-16 w-240'>車身形式：{item.autoType}</div>
                                <div className='text-[#666666] text-16'>{`${item.energyType === 5 ? `續航：${item.batteryLife}km` : `油耗：${item.oil}`}`}</div>
                              </div>
                            </a>

                            {Array.isArray(item.models) &&
                              !!item.models.length &&
                              item.models.map((i, idx) => (
                                <a href={`${host.c}/${setUrlFormat(item.brandName)}/${setUrlFormat(item.kindName)}/Specification.html`} className='flex justify-between mb-14 pr-30' key={idx}>
                                  <div className='text-[#333333] text-16'>{i.fullName}</div>
                                  <div className='text-[#666666] text-16 font-medium'>{i.price}</div>
                                </a>
                              ))}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>

              <div>
                {/* 熱門文章 */}
                {kind !== "" && (
                  <ArticlesRank
                    title={<p style={{ fontSize: "28px", fontWeight: "500" }}>相關文章</p>}
                    fetchData={{ limit: 10, kindId: kind }}
                    fetchFun={fetchV3Articles}
                    fetchKey='categoryFetchV3Articles'
                  />
                )}

                <div className='mt-40'>
                  <HotMovie limit={10} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </WrapperProvider>
    );
  }
}

withLayout({
  cmp: <KindListDetail />,
  params: {
    AdTopBanner: true,
    nav: "DefaultFixedNav",
    footer: "Footer",
  },
});
